import { Flex } from 'antd'
import { RotatedTitle } from '../../../../components/rotated-title/rotated-title'
import ShipmentTypeCheckbox from '../../components/calculation-form/components/form-items/shipment-type'
import { renderCalcPos, onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const shipmentTypeColumn: CalculationColumn = {
    dataIndex: 'shipmentType',
    title: <RotatedTitle style={{ whiteSpace: 'nowrap' }}>ЦП</RotatedTitle>,
    width: 32,
    render: renderCalcPos(r => {
        return (
            <Flex justify={'center'}>
                <ShipmentTypeCheckbox record={r} checked={r.shipmentType === 'colorProof'} />
            </Flex>
        )
    }),
    onCell: onAnyStandardCell,
}
